import * as Papa from 'papaparse';
import * as React from 'react';

import {
  VoiceboxResponseActionType,
  VoiceboxResponseMessage,
} from 'bones/constants/voicebox/message';

const useParsedCsv = (csv: string | null) => {
  const [parsed, setParsed] = React.useState<Papa.ParseResult<
    Record<string, string>
  > | null>(null);

  React.useEffect(() => {
    if (csv) {
      Papa.parse<Record<string, string>>(csv, {
        complete: (results) => {
          setParsed(results);
        },
        header: true,
        skipEmptyLines: true,
      });
    }
  }, [csv]);

  return parsed;
};

export const useParsedCsvFromMessage = (message: VoiceboxResponseMessage) => {
  // sparql isn't used currently, except within this hook to determine
  // whether to show CSV or not
  const { csv, sparql: _sparql } = React.useMemo(() => {
    const csvs: string[] = [];
    const sparqls: string[] = [];
    message.actions?.forEach(({ type, value }) => {
      if (type === VoiceboxResponseActionType.CSV) {
        csvs.push(value);
      }
      if (type === VoiceboxResponseActionType.SPARQL) {
        sparqls.push(value);
      }
    });

    // if we have more than 1 csv or sparql action, don't show the csv table
    // so that this case is noticed early on and can be handled here
    let csv = null;
    let sparql = null;
    if (csvs.length === 1 && sparqls.length === 1) {
      [csv] = csvs;
      [sparql] = sparqls;
    } else if (!csvs.length) {
      // do nothing if there are no CSV actions
    } else if (!sparqls.length) {
      console.warn('Missing SPARQL action; refusing to show CSV table', {
        csvs,
        sparqls,
        message,
      });
    } else {
      console.warn(
        'Got more than 1 SPARQL or CSV actions; refusing to show CSV table',
        { csvs, sparqls, message }
      );
    }

    return { csv, sparql };
  }, [message]);

  const parsed = useParsedCsv(csv);

  return parsed;
};
